'use strict';

export class DonorList {
    #page;
    #totalPages;
    #paginationContainer;
    #nextButton;
    #prevButton;
    #currentIndicator;

    constructor() {
        this.#page = 1;
        this.#paginationContainer = document.getElementById(
            'p2p-donors-pagination'
        );
        if (this.#paginationContainer) {
            this.#totalPages =
                (this.#paginationContainer.dataset.totalPages ?? 1) * 1;
            this.#nextButton = this.#paginationContainer.querySelector('.next');
            this.#prevButton = this.#paginationContainer.querySelector('.prev');
            this.#currentIndicator = this.#paginationContainer
                .querySelector('.pagination-indicator')
                .querySelector('.current');
        }
    }
    watchPagination() {
        if ( ! this.#paginationContainer ) {
            return;
        }

        document.addEventListener('click', (event) => {
            let paginationNextButton = false;
            if(event.target.matches('.pagination-button.next')){
                paginationNextButton = true;
            }else if(event.target.closest('.pagination-button.next')){
                paginationNextButton = true;
            }
            if (paginationNextButton && this.#page < this.#totalPages) {
                this.#page++;
                this.#paginate();
            }

            let paginationPrevButton = false;
            if(event.target.matches('.pagination-button.prev')){
                paginationPrevButton = true;
            }else if(event.target.closest('.pagination-button.prev')){
                paginationPrevButton = true;
            }

            if (paginationPrevButton && this.#page > 1 ) {
                this.#page--;
                this.#paginate();
            }
        });

        this.#disableButtons();

    }

    #paginate() {
        this.#disableButtons();
        let displayProperty;
        document
            .querySelectorAll( '.p2p_campaign_donation' )
            .forEach( ( donorItem ) => {
                displayProperty =
                    donorItem.dataset.page != this.#page ? 'none' : 'block';
                donorItem.style.display = displayProperty;
            } );
    }
    #disableButtons() {
        if ( this.#page === 1 ) {
            this.#prevButton.classList.add( 'disabled' );
        } else {
            this.#prevButton.classList.remove( 'disabled' );
        }
        if ( this.#page === this.#totalPages ) {
            this.#nextButton.classList.add( 'disabled' );
        } else {
            this.#nextButton.classList.remove( 'disabled' );
        }
        this.#currentIndicator.innerHTML =
            this.#page < 10 ? `0${ this.#page }` : this.#page;
    }
}